{
    "deploy": "Deploy",
    "deployToEngine": "Deploy to ATB Engine",
    "engine": "ATB Engine",
    "deploymentFile": "Deployment File",
    "deploymentFileName": "Deployment File Name",
    "selectDeploymentFile": "Select a deployment file",
    "selectedFile": "Selected file",
    "invalidFileType": "Invalid file type. Please select a .zip file",
    "inputData": "Input Data",
    "unzipInput": "Unzip Input",
    "default": "Default",
    "defaultFalse": "Default: False",
    "defaultTrue": "Default: True",
    "cancel": "Cancel",
    "startDeployment": "Start Deployment",
    "deploySuccessful": "Deployed successfully",
    "deployFailed": "Failed to deploy",
    "selectedInputFile": "Selected input file",
    "refreshInputManifest": "Refresh input files",
    "deploying": "Deploying",
    "uploadingDeployment": "Submitting File",
    "deployProgressMessage": "Deploying to engine..."
}